export const getFingerprintState = (state) => state.fingerprint;
export const getFingerprintVisitorId = (state) => state.fingerprint.data.visitorId
